import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allRegionsOrSearch: [],
  flatRegions: [],
  flatRegionData: {},
  flatRegionMetaData: {},
  regionData: {},
  regionMetaData: {},
  isRegionEditPageRelod: true,
  isUpdating: false,
  openDeleteModal: false,
  flatRegionToBeDelete: {
    id: "",
    name: "",
  },
  RegionToBeDelete: {
    id: "",
    name: "",
  },
  flatPriorityRegions: [],
};

const regionSlice = createSlice({
  name: "region",
  initialState: initialState,
  reducers: {
    setFlatRegionToBeDelete: (state, action) => {
      state.flatRegionToBeDelete = action.payload.flatRegionToBeDelete;
    },
    setRegionToBeDelete: (state, action) => {
      state.RegionToBeDelete = action.payload.RegionToBeDelete;
    },

    setOpenDeleteModal: (state, action) => {
      state.openDeleteModal = action.payload.openDeleteModal;
    },
    setIsUpdating: (state, action) => {
      state.isUpdating = action.payload.isUpdating;
    },
    setAllRegions: (state, action) => {
      state.allRegionsOrSearch = action.payload.allRegionsOrSearch;
    },
    getRegion: (state, action) => {
      state.regionData = action.payload.region;
    },
    setIsRegionEditPageRelod: (state, action) => {
      state.isRegionEditPageRelod = action.payload.isRegionEditPageRelod;
    },
    setFlatRegions: (state, action) => {
      state.flatRegions = action.payload.flatRegions;
    },
    setFlatRegionData: (state, action) => {
      state.flatRegionData = action.payload.flatRegionData;
    },
    setRegionMetaData: (state, action) => {
      state.regionMetaData = action.payload.regionMetaData;
    },
    setFlatRegionMetaData: (state, action) => {
      state.flatRegionMetaData = action.payload.flatRegionMetaData;
    },
    setFlatPriorityRegions: (state, action) => {
      state.flatPriorityRegions = action.payload.flatPriorityRegions;
      console.log("====================================");
      console.log(state.flatPriorityRegions, "state.flatPriorityRegions");
      console.log("====================================");
    },
  },
});

export const {
  setFlatRegions,
  setIsUpdating,
  setAllRegions,
  getRegion,
  setIsRegionEditPageRelod,
  setOpenDeleteModal,
  setFlatRegionData,
  setRegionMetaData,
  setFlatRegionMetaData,
  setFlatRegionToBeDelete,
  setRegionToBeDelete,
  setFlatPriorityRegions,
} = regionSlice.actions;
export const regionSliceReducer = regionSlice.reducer;
